<script setup>
import { ref, defineProps, defineModel } from 'vue'

const menu = ref(false)
const dateFormatted = defineModel()
const time = ref(null)
const crtProps = defineProps(['label', 'style', 'class', 'variant', 'density', 'hideDetails'])

const crtVarian = !crtProps.variant ? 'solo' : crtProps.variant
const crtDensity = !crtProps.density ? 'compact' : crtProps.density
const crtHideDetails = crtProps.hideDetails == undefined ? true : crtProps.hideDetails

function updateHour(value) {    
    let result = '';
    if(value < 9) {
        result = '0' + value;
    }
    else {
        result = '' + value;
    }
    let elm = dateFormatted.value ? dateFormatted.value.split(':') : '';
    if(elm.length == 2) {
        result = `${result}:${elm[1]}`;
    }
    else {
        result = `${result}:00`;
    }
    dateFormatted.value = result;
    //emit('update:modelValue', result)
}

function updateMinute(value) {
    let result = '';
    if(value < 9) {
        result = '0' + value;
    }
    else {
        result = '' + value;
    }
    let elm = dateFormatted.value ? dateFormatted.value.split(':') : '';
    if(elm.length == 2) {
        result = `${elm[0]}:${result}`;
    }
    else {
        result = `00:${result}`;
    }
    dateFormatted.value = result;
    //emit('update:modelValue', result)
}


</script>

<template>
    <div :class="crtProps.class">
        <v-text-field :label="crtProps.label" 
            autocomplete="one-time-code"
            :variant="crtVarian" 
            :density="crtDensity" 
            v-model="dateFormatted"
            :hide-details="crtHideDetails" >
            <v-menu v-model="menu" 
                :close-on-content-click="false" 
                activator="parent" >
                <v-card>
                    <v-card-title>
                        <v-btn icon="mdi-close" density="compact" variant="text" @click="menu = false" ></v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-time-picker v-model="time" format="24hr" @update:hour="updateHour" @update:minute="updateMinute"></v-time-picker>
                    </v-card-text>
                </v-card>
            </v-menu>
        </v-text-field>
    </div>
</template>